import { Collection } from '@ai-platform/database';
import { Course, Challenge } from '@ai-platform/utils';
import { transformCourseToCard } from '../course/mappers';

/**
 * Адаптация данных курса из API под формат frontend
 */
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformApiCoursesToFrontend = (apiCourse: Course): any => {
    return {
        ...transformCourseToCard(apiCourse),
        type: 'course',
    };
};

/**
 * Адаптация данных челленджа из API под формат frontend
 */
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformApiChallengesToFrontend = (apiChallenge: Challenge): any => {
    return {
        ...apiChallenge,
        type: 'challenge',
    };
};

/**
 * Адаптация данных подборки из API под формат frontend
 */
export const transformApiCollectionToFrontend = (apiCollection: Collection) => {
    return {
        ...apiCollection,
        type: 'collection',
    };
};
